import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { INIT_STATE } from "actions/initialise";

const loading = (state = initialState.loading, action: any) => {
  switch (action.type) {
    case pending(INIT_STATE):
      return true;
    case fulfilled(INIT_STATE):
    case failed(INIT_STATE):
      return false;
    default:
      return state;
  }
};

export default loading;
